export enum ESupportedLanguages {
  English = 'en',
  Hindi = 'hi',
}
